<script setup>
  import { BtnVariant } from '../../enums/btn-variant.js'
  import { computed } from 'vue'
  import AppIcon from '../ui/AppIcon.vue'

  const props = defineProps({
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isNoActive: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '46px'
    },
    icon: {
      type: Boolean,
      default: false
    },
    isGrey: {
      type: Boolean,
      default: false
    },
    isRed: {
      type: Boolean,
      default: false
    }
  })

  const variantClass = computed(() => {
    const defaultCLass =
      (!props.disabled && !props.loading && !props.isNoActive
        ? ' bg-main-gradient hover:bg-hover-gradient active:bg-outline-btn-gradient active:shadow-primary-active-btn '
        : ' cursor-default') +
      (props.disabled ? ' !bg-disabled-btn !text-disabled-btn-text' : '') +
      (props.isNoActive
        ? ' !bg-not-active-gradient opacity-40 pointer-events-none'
        : '') +
      (props.loading
        ? ' bg-main-gradient border-default border-loading-border'
        : '')
    switch (props.variant) {
      case BtnVariant.Primary:
        return defaultCLass

      case BtnVariant.Secondary:
        return (
          (!props.disabled &&
          !props.loading &&
          !props.isNoActive &&
          !props.isGrey &&
          !props.isRed
            ? ' bg-secondary-btn-bg hover:bg-secondary-btn-hover-bg active:shadow-secondary-active-btn'
            : ' cursor-default') +
          (props.disabled ? ' !bg-disabled-btn !text-disabled-btn-text' : '') +
          (props.isNoActive
            ? ' !text-secondary-btn-not-active-text opacity-40'
            : '') +
          (props.isGrey ? ' !text-dark !bg-secondary-btn' : '') +
          (props.isRed ? ' !hover:bg-error/50 !bg-error' : '')
        )

      case BtnVariant.Outline:
        return (
          (!props.disabled && !props.loading && !props.isNoActive
            ? ' bg-transparent border-2 border-stroke hover:bg-outline-btn-bg active:border-none active:bg-outline-btn-gradient active:shadow-primary-active-btn'
            : ' cursor-default') +
          (props.disabled
            ? ' !border-none !bg-disabled-btn !text-disabled-btn-text'
            : '') +
          (props.isNoActive ? ' !bg-not-active-gradient opacity-40' : '') +
          (props.loading ? ' !border border-loading-border' : '')
        )
      default:
        return defaultCLass
    }
  })
</script>

<template>
  <button
    :type="type ? type : 'button'"
    class="app-button"
    :class="variantClass"
    :style="{ height: height }"
    :disabled="disabled || loading"
  >
    <div
      v-if="icon"
      class="text-white flex items-center justify-center"
    >
      <!-- <app-icon
        :name="icon"
        :height="iconHeight"
        :width="iconWidth"
      /> -->
      <slot></slot>
    </div>

    <span
      v-if="loading"
      class="loader me-2"
    />
    <span
      class="shrink-0"
      :class="{ '!text-dark': isGrey }"
    >
      {{ loading ? 'Loading..' : text }}
    </span>
  </button>
</template>

<style scoped lang="scss">
  .app-button {
    @apply flex cursor-pointer items-center justify-center w-full h-[46px] font-medium rounded-lg text-[12px] text-white px-2;
    @apply sm:text-sm;
  }
  .loader {
    display: block;
    position: relative;
    height: 12px;
    width: 32px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    overflow: hidden;
  }
  .loader::after {
    content: '';
    width: 8px;
    height: 64%;
    background: #fff;
    border-radius: 12px;
    position: absolute;
    top: 18%;
    left: 0;
    box-sizing: border-box;
    animation: animloader 1s ease-in infinite;
  }

  @keyframes animloader {
    0% {
      left: 0;
      transform: translateX(-90%);
      width: 10%;
    }
    20% {
      left: 40%;
      transform: translateX(-50%);
      width: 50%;
    }
    50% {
      left: 100%;
      transform: translateX(0%);
      width: 20%;
    }
    100% {
      left: 100%;
      transform: translateX(0%);
      width: 0;
    }
  }
</style>
